var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    key: _vm.blob.giftcard.id,
    staticClass: "absolute-fill elevation-8 gc-border"
  }, [_vm.placeholder ? _c('div', {
    staticClass: "absolute-fill placeholder"
  }) : _vm._e(), _vm.blob.giftcard.product_img == 'https://cdn.ellacard.com/giftcards_gift_of_choice.jpg' ? _c('video', {
    staticClass: "user-select-none gc-border",
    attrs: {
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": "",
      "draggable": "false",
      "width": "100%",
      "poster": "//cdn.ellacard.com/media/e2ef27c8-b84f-4026-9db7-65af3168ae22/md.webp",
      "src": "//cdn.ellacard.com/media/e2ef27c8-b84f-4026-9db7-65af3168ae22/md.mp4"
    },
    domProps: {
      "muted": true
    },
    on: {
      "loadedmetadata": _vm.onLoad,
      "error": _vm.onLoad
    }
  }) : _c('img', {
    staticClass: "user-select-none gc-border",
    attrs: {
      "src": _vm.blob.giftcard.product_img,
      "draggable": "false"
    },
    on: {
      "load": _vm.onLoad
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }